module.exports = __webpack_public_path__ + "images/icons_v2/credit-card-outlined-11c422e4.svg";